<script>
	import { afterUpdate, getContext } from "svelte";
	import Week from "./Week.svelte";
	import { localeContext } from "@xbs/lib-scheduler";
	import { getDayOfYear, getMonth, isAfter } from "date-fns";
	import { fly, fade } from "svelte/transition";

	export let model = {};
	export let selected;

	let table;
	let scrollWidth;
	const dateFormat =
		getContext(localeContext).getGroup("scheduler")("monthFormat");

	const templates = getContext("schedulerTemplates");

	$: ({ weekDays, monthTable, calendars, config, activeDate } = model);

	afterUpdate(() => {
		scrollWidth = table.offsetWidth - table.clientWidth + 1.5;
	});
	let x = 0;
	let prevDate = null;
	$: {
		const newDate = monthTable[0].start_date;
		x = isAfter(newDate, prevDate) ? 50 : -50;
		prevDate = newDate;
	}

</script>

<div class="wx-event-calendar-layout">
	<div class="wx-event-calendar-weekdays" in:fade>
		{#each weekDays as day}
			<div class="wx-event-calendar-weekday">
				<svelte:component
					this={templates.header}
					date={day.label}
					{dateFormat} />
			</div>
		{/each}
		{#if scrollWidth}
			<div style="width:{scrollWidth}px" />
		{/if}
	</div>
	{#key getMonth(activeDate)}
		<div
			class="wx-event-calendar-table"
			in:fly={{ x, duration: 700 }}
			bind:this={table}>
			{#each monthTable as week (getDayOfYear(week.start_date))}
				<Week {selected} {week} {calendars} {config} on:action />
			{/each}
		</div>
	{/key}
</div>

<style>
	.wx-event-calendar-layout {
		position: relative;
		flex: 1;
		display: flex;
		flex-direction: column;
		color: var(--wx-color-font);
	}

	.wx-event-calendar-weekdays {
		display: flex;
		border-bottom: var(--wx-border);
		margin-left: -1px;
		color: var(--wx-color-font-alt);
	}

	.wx-event-calendar-weekday {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		flex-shrink: 0;
		text-transform: capitalize;
	}

	.wx-event-calendar-table {
		flex: 1;
		overflow: auto;
	}

</style>
